import styled, { css } from 'styled-components';
import themes, { colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import media from '../../media';
export const SubmenuHeader = styled.div `
  ${({ theme, contrast }) => css `
    position: relative;
    color: ${contrast ? colors.solid.bgWhite : colors.solid.textOne};
    background-color: ${contrast ? themes.dark.palette.background.default : colors.solid.bgGrey}};
    text-decoration: none;
    display: flex;
    align-content: center;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    cursor: pointer;
    margin: ${theme.spacing.unit}px 24px;
    white-space: nowrap;
  `}

  & > span {
    width: fit-content;
  }

  & svg {
    color: ${colors.solid.textOne};
    padding-left: 9px;
    margin: unset;
  }
`;
export const Link = styled.a `
  ${({ theme, contrast }) => css `
    position: relative;
    color: ${contrast ? colors.solid.bgWhite : colors.solid.textOne};
    background-color: ${contrast ? themes.dark.palette.background.default : colors.solid.bgGrey}}

    text-decoration: none;
    display: flex;
    align-content: center;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    /* cursor: pointer; */
    margin: ${theme.spacing.unit}px 24px;
    white-space: nowrap;
  `}
`;
export const SimpleLink = styled.a `
  ${({ theme, contrast }) => css `
    position: relative;
    color: ${contrast ? colors.solid.bgWhite : colors.solid.textOne};
    background-color: ${contrast ? themes.dark.palette.background.default : colors.solid.bgGrey}};
    text-decoration: none;
    display: flex;
    align-content: center;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    cursor: pointer;
    margin: ${theme.spacing.unit}px 24px;
    white-space: nowrap;
  `}

  & > span {
    width: fit-content;
    padding: 6px 0;
  }
`;
export const Wrapper = styled.div `
  display: none;
  margin-left: 65px;

  ${media.xl `
    display: flex;
    justify-content: center;
  `}

  ${({ theme, isMobile = false, contrast }) => css `
    ${isMobile &&
    css `
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      text-align: left;
      margin-left: 0;
      padding-bottom: ${theme.spacing.unit * 4}px;
      overflow-y: scroll;
      background-color: ${contrast ? themes.dark.palette.background.default : colors.solid.bgGrey}}

      & > ${Link}, ${SubmenuHeader} {
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 32px;
        color: ${contrast ? colors.solid.bgWhite : colors.solid.textOne};
        display: block;
        margin: 16px 30px;
      }

      ${media.md `
        & > ${Link}, ${SubmenuHeader} {
          margin: 16px 70px;
        }
      `}
    `}
  `}
`;
//# sourceMappingURL=styled.js.map